/* eslint-disable no-undef */
import "./assets/css/App.css";
import "./assets/css/advancedmarker.css";
import React, { useEffect } from "react";
import "swiper/css/pagination";
import "swiper/css/effect-coverflow";
import "swiper/css";
import "swiper/css/navigation";
import MainPage from "./pages/MainPage";
import VoyageDetailsPage from "./pages/VoyageDetailsPage";
import ProfilePage from "./pages/ProfilePage";
import ConnectPage from "./pages/ConnectPage";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import VehicleDetailsPage from "./pages/VehicleDetailsPage";
import ProfilePagePublic from "./pages/ProfilePagePublic";
import FavoritesPage from "./pages/FavoritesPage";
import LoginPage from "./pages/LoginPage";
import CreateVehiclePage from "./pages/CreateVehiclePage";
import CreateVoyagePage from "./pages/CreateVoyagePage";
import { EditProfilePage } from "./pages/EditProfilePage";
import EditVehiclePage from "./pages/EditVehiclePage";
import { useDispatch, useSelector } from "react-redux";
import { initHubConnection } from "./signalr/signalRHub";
import { ParrotCoinPage } from "./pages/ParrotCoinPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AdminPage from "./pages/AdminPage";
import { ErrorBoundary } from "./components/ErrorBoundary";
const API_URL = process.env.REACT_APP_API_URL;

function App() {
  var isLoggedIn = useSelector((state) => state.users.isLoggedIn);
  const isDarkMode = useSelector((state) => state.users.isDarkMode);
  const bgImageVariant = useSelector((state) => state.users.bgImageVariant);
  const currentUserId = useSelector((state) => state.users.userId);
  const userName = useSelector((state) => state.users.userName);
  const dispatch = useDispatch()

  useEffect(() => {
    if (isLoggedIn && currentUserId) {
      // Initialize the SignalR hub once for the app
      initHubConnection(currentUserId, API_URL);
    }
  }, [isLoggedIn, currentUserId]);

  useEffect(() => {
    if (userName) {
      document.title = `${userName} @ Parrots App`;
    }
  }, [userName]);

  useEffect(() => {
    const image = bgImageVariant === "new"
      ? require("./assets/images/seafromabove1.jpg")
      : require("./assets/images/seafromsky.jpg");
    document.body.style.backgroundImage = `url(${image})`;
    document.body.style.backgroundSize = "cover";
    document.body.style.backgroundPosition = "center";
    document.body.style.backgroundAttachment = "fixed";
  }, [bgImageVariant]);

  useEffect(() => {


    if (!currentUserId) return; // <- guard against null

    console.log("unread message useEffect");
    const InitHub = async () => {
      try {
        // Start SignalR
        await initHubConnection(currentUserId, API_URL);
      } catch (error) {
        console.log(error);
      }
    };
    InitHub();
    return () => {
      // stopHubConnection();
    };
  }, [currentUserId]);



  useEffect(() => {
    const handleOffline = () => toast.error("You are offline. Check your connection.", { toastId: "offline", autoClose: false });
    const handleOnline = () => { toast.dismiss("offline"); toast.success("Back online.", { autoClose: 2000 }); };
    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);
    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
  }, []);



  return (
    <ErrorBoundary>
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        {!isLoggedIn ? (
          <Route path="*" element={<Navigate to="/login" />} />
        ) : (
          <>
            <Route path="/" element={<MainPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/parrotcoinpage" element={<ParrotCoinPage />} />
            <Route path="/edit-profile" element={<EditProfilePage />} />
            <Route path="/newVehicle" element={<CreateVehiclePage />} />
            <Route path="/newVoyage" element={<CreateVoyagePage />} />
            <Route
              path="/profile-public/:userId/:userName" // using publicId for userId
              element={<ProfilePagePublic />}
            />
            <Route
              path="/voyage-details/:voyageId"
              element={<VoyageDetailsPage />}
            />
            <Route
              path="/vehicle-details/:vehicleId"
              element={<VehicleDetailsPage />}
            />
            <Route
              path="/edit-vehicle/:vehicleId"
              element={<EditVehiclePage />}
            />
            <Route path="/favorites" element={<FavoritesPage />} />
            <Route path="/connect" element={<ConnectPage />} />
            <Route
              path="/connect/:conversationUserId/:conversationUserUsername"
              element={<ConnectPage />}
            />
          </>
        )}
      </Routes>
      <ToastContainer
        position="bottom-center"
        autoClose={2500}
        hideProgressBar
        closeButton={false}
        icon={false}
        toastClassName="parrot-pill-toast"
        bodyClassName="parrot-pill-toast-body"
      />

    </Router>
    </ErrorBoundary>
  );
}

export default App;
